export default async function getMoreThemes(fetch) {
    const resp = await fetch('/graphql', {
        body: JSON.stringify({
            query: '{themes(limit:4,rand:true){id,title,installs,workspace}}',
        }),
    });

    const { data } = await resp.json();

    if (!data || !data.themes) {
        return [];
    }

    return data.themes;
};